"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var withTooltip_1 = __importDefault(require("relements/build/esm/overlays/withTooltip"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
require("./TextLabel.scss");
/**
 * Component to display read-only data
 * Accepts array of strings and usual string as value
 * If an array is sent, the component can return data in "a,b,c & 5 more" format
 */
var TextLabel = function (_a) {
    var label = _a.label, value = _a.value, className = _a.className, itemsToDisplay = _a.itemsToDisplay, tooltip = _a.tooltip;
    // Converts an Array of strings and adds space after each comma
    var convertArrayToString = function (array) {
        return array.toString().replace(/,/g, ', ');
    };
    // Get Input value
    var getInputValue = function () {
        var returnValue = value;
        // Used only if value is array
        // Includes those values which are to be shown in tooltip
        var extraValues = [];
        // If value is an array, limit items shown and add rest in tooltip
        if (Array.isArray(value)) {
            var valuesToDisplay = value;
            if (value.length > itemsToDisplay) {
                // Slice incoming array and display only those number of items
                // specified in 'itemsToDisplay' prop
                valuesToDisplay = value.slice(0, itemsToDisplay);
                // Get items other than ones which are present in above array
                extraValues = value.slice(itemsToDisplay);
            }
            returnValue = convertArrayToString(valuesToDisplay);
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, null,
            returnValue,
            extraValues.length > 0 && (react_1["default"].createElement(react_1["default"].Fragment, null,
                "...",
                react_1["default"].createElement(withTooltip_1["default"], { tooltip: convertArrayToString(extraValues), position: "BOTTOM", className: "textLabelExtraValues" }, extraValues.length + " more")))));
    };
    return (react_1["default"].createElement("div", { className: "textLabel " + className, style: {
            minHeight: Array.isArray(value) ? 52 : 'auto'
        } },
        label && (react_1["default"].createElement("div", { className: "textLabelTitle" },
            label,
            tooltip && (react_1["default"].createElement(withTooltip_1["default"], { className: "textLabelTitleTooltip", tooltip: tooltip, position: "TOP" },
                react_1["default"].createElement(icon_1["default"], { src: 'info', className: "textLabelTitleTooltipIcon" }))))),
        react_1["default"].createElement("div", { className: "textLabelContent" }, getInputValue())));
};
exports["default"] = TextLabel;
